/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал получения реквизитов для авторизации в омничате
 */

/**
 * Сервис для авторизации в омничате
 */
export class CredentialsServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получение реквизитов для авторизации в Omnichat.
   * Метод доступен для: master, employee, owner
   */
  PostCredentials = (req: PostCredentialsRequestDto, init?: RequestInit): Promise<PostCredentialsResponseDto> => {
    return fm.request<PostCredentialsRequestDto, PostCredentialsResponseDto>(`${this.host}/omnichat/api/v1/credentials`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Метаданные клиента
 */
export type ClientMetadataRequestDto = {
  /**
   * Версия приложения.
   * # Диапазон: 1..128
   */
  appVersion?: string | null
  /**
   * Версия операционной системы.
   * # Диапазон: 1..128
   */
  osVersion?: string | null
  /**
   * Модель устройства.
   * # Диапазон: 1..128
   */
  deviceModel?: string | null
  /**
   * Название приложения.
   * Для разных приложений мы можем использовать разные tenantId и channel_id, сопоставление хранится в конфиге сервиса
   */
  appName: string
}
/**
 * Метаданные клиента
 */
export type ClientMetadataResponseDto = {
  /**
   * Версия приложения.
   * # Диапазон: 1..128
   */
  appVersion: string | null
  /**
   * Версия операционной системы.
   * # Диапазон: 1..128
   */
  osVersion: string | null
  /**
   * Модель устройства.
   * # Диапазон: 1..128
   */
  deviceModel: string | null
  /**
   * Название приложения.
   * Для разных приложений мы можем использовать разные tenantId и channel_id, сопоставление хранится в конфиге сервиса
   */
  appName: string
}
/**
 * Реквезиты для авторизации в omnichat
 */
export type CredentialsRequestDto = {
  /**
   * Закодированные в base64 клиентские данные.
   * Состав: appVersion, os, deviceModel, tenantId, login, phone, email, group_id, address, лицевые счета
   */
  payload: string
  /**
   * HMAC-подпись от payload (клиентских данных)
   */
  hash: string
  /**
   * Идентификатор канала в omnichat.
   * Определяется исходя из типа приложения
   */
  channelId: number
}
/**
 * Реквезиты для авторизации в omnichat
 */
export type CredentialsResponseDto = {
  /**
   * Закодированные в base64 клиентские данные.
   * Состав: appVersion, os, deviceModel, tenantId, login, phone, email, group_id, address, лицевые счета
   */
  payload: string
  /**
   * HMAC-подпись от payload (клиентских данных)
   */
  hash: string
  /**
   * Идентификатор канала в omnichat.
   * Определяется исходя из типа приложения
   */
  channelId: number
}
/**
 * Запрос реквезитов для авторизации в Omnichat
 */
export type PostCredentialsRequestDto = {
  /**
   * Метаданные клиента
   */
  clientMetadata: ClientMetadataRequestDto
}
/**
 * Ответ на запрос реквезитов для авторизации в Omnichat
 */
export type PostCredentialsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Реквизиты
   */
  readonly data: CredentialsResponseDto
  /**
   * Ошибка
   */
  readonly error: PostCredentialsResponseErrorDto
}>
/**
 * Ошибка запроса получения хешированной информации о пользователе
 */
export type PostCredentialsResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Переданное название приложения не поддерживается
   */
  readonly appNameUnsupported: PostCredentialsResponseErrorAppNameUnsupportedRequestDto
}>
/**
 * Ошибка запроса получения хешированной информации о пользователе
 */
export type PostCredentialsResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Переданное название приложения не поддерживается
   */
  readonly appNameUnsupported: PostCredentialsResponseErrorAppNameUnsupportedDto
}>
/**
 * Переданное название приложения не поддерживается
 */
export type PostCredentialsResponseErrorAppNameUnsupportedRequestDto = {
}
/**
 * Переданное название приложения не поддерживается
 */
export type PostCredentialsResponseErrorAppNameUnsupportedDto = {
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Метаданные клиента
   */
  "ClientMetadata": {
    "kind": "class",
    "text": "Метаданные клиента",
    "fields": {
      /**
       * Версия приложения.
       * # Диапазон: 1..128
       */
      "appVersion": {
        "type": "google.protobuf.StringValue",
        "text": "Версия приложения.\n# Диапазон: 1..128",
        "rules": {
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 128,
            "message": "Значение не входит в допустимый диапазон. Максимум: 128"
          },
        }
      },
      /**
       * Версия операционной системы.
       * # Диапазон: 1..128
       */
      "osVersion": {
        "type": "google.protobuf.StringValue",
        "text": "Версия операционной системы.\n# Диапазон: 1..128",
        "rules": {
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 128,
            "message": "Значение не входит в допустимый диапазон. Максимум: 128"
          },
        }
      },
      /**
       * Модель устройства.
       * # Диапазон: 1..128
       */
      "deviceModel": {
        "type": "google.protobuf.StringValue",
        "text": "Модель устройства.\n# Диапазон: 1..128",
        "rules": {
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 128,
            "message": "Значение не входит в допустимый диапазон. Максимум: 128"
          },
        }
      },
      /**
       * Название приложения.
       * Для разных приложений мы можем использовать разные tenantId и channel_id, сопоставление хранится в конфиге сервиса
       */
      "appName": {
        "type": "string",
        "text": "Название приложения.\nДля разных приложений мы можем использовать разные tenantId и channel_id, сопоставление хранится в конфиге сервиса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Реквезиты для авторизации в omnichat
   */
  "Credentials": {
    "kind": "class",
    "text": "Реквезиты для авторизации в omnichat",
    "fields": {
      /**
       * Закодированные в base64 клиентские данные.
       * Состав: appVersion, os, deviceModel, tenantId, login, phone, email, group_id, address, лицевые счета
       */
      "payload": {
        "type": "string",
        "text": "Закодированные в base64 клиентские данные.\nСостав: appVersion, os, deviceModel, tenantId, login, phone, email, group_id, address, лицевые счета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * HMAC-подпись от payload (клиентских данных)
       */
      "hash": {
        "type": "string",
        "text": "HMAC-подпись от payload (клиентских данных)",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор канала в omnichat.
       * Определяется исходя из типа приложения
       */
      "channelId": {
        "type": "int32",
        "text": "Идентификатор канала в omnichat.\nОпределяется исходя из типа приложения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Запрос реквезитов для авторизации в Omnichat
   */
  "PostCredentialsRequest": {
    "kind": "class",
    "text": "Запрос реквезитов для авторизации в Omnichat",
    "fields": {
      /**
       * Метаданные клиента
       */
      "clientMetadata": {
        "type": "ClientMetadata",
        "text": "Метаданные клиента",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос реквезитов для авторизации в Omnichat
   */
  "PostCredentialsResponse": {
    "kind": "class",
    "text": "Ответ на запрос реквезитов для авторизации в Omnichat",
    "fields": {
      /**
       * Реквизиты
       */
      "data": {
        "type": "Credentials",
        "text": "Реквизиты",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostCredentialsResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения хешированной информации о пользователе
   */
  "PostCredentialsResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения хешированной информации о пользователе",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Переданное название приложения не поддерживается
       */
      "appNameUnsupported": {
        "type": "PostCredentialsResponse.Error.AppNameUnsupported",
        "text": "Переданное название приложения не поддерживается",
      },
    },
  },
  /**
   * Переданное название приложения не поддерживается
   */
  "PostCredentialsResponse.Error.AppNameUnsupported": {
    "kind": "class",
    "text": "Переданное название приложения не поддерживается",
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}